import modalSlice from "./modalSlice";
const modalActions = modalSlice.actions;
export const {
  setLoginVisible,
  setLeavePageVisible,
  setPaymentStatusVisible,
  setForgotPasswordVisible,
  setNotPayableVisible,
  setIDMatchVisible,
  setAreYouSureVisible,
} = modalActions;
